

/*
 * расчитываем даты прилётов 
 */
export const GetDates = schedules => {

    // проходимся по всем направлениям
    for (const item of schedules) {
        // в направлениях проходимся по расписаниям
        for (const item2 of item) {
            // в направлениях проходимся по рейсам
            for (const flight of item2.flights) {

                // массив для дат прилётов
                flight.dates = [];

                // ?<--------------------------------------------------------------------------------------------------------------->

                // массив дней недели
                let weekDays = flight.weekday.split('');
                // приобразуем элементы массива в числа
                weekDays = weekDays.map(elem => {
                    if (+elem === 7) return 0

                    return +elem
                });

                // ?<--------------------------------------------------------------------------------------------------------------->

                // дата начала активности рейса 
                let beginDate = flight.begin_date.split('.');
                beginDate = new Date(beginDate[2], beginDate[1] - 1, beginDate[0]).getTime();
                // дата окончания активности
                let endDate = flight.end_date.split('.');
                endDate = new Date(endDate[2], endDate[1] - 1, endDate[0]).getTime();

                // ?<--------------------------------------------------------------------------------------------------------------->

                for (let index = beginDate; index <= endDate; index += 86400 * 1000) {
                    let date = new Date(index);

                    if (weekDays.includes(date.getDay())) {
                        flight.dates.push(date.toLocaleDateString('ru-Ru', { day: '2-digit', month: '2-digit', year: 'numeric' }));
                    }
                }
            }
        }
    }

    return schedules;
}